import AbstractModel from './AbstractModel';
import {INavigationSetting} from '../../../@interfaces/services/Database/INavigationSetting';
import {IReduxNavigationState} from '../../../@interfaces';
import {INavigationItem} from '../../../@interfaces/Navigation';

export default class NavigationSetting extends AbstractModel<INavigationSetting> implements INavigationSetting {
	readonly name!: Exclude<keyof IReduxNavigationState, 'loaded'>;
	readonly routes!: INavigationItem[];

	protected get table() {
		return this.connection.navigationSettings;
	}
}
